export const MAIN_LAUNCHER_PATH = "/launch/888debug";

const LAUNCHER_PATHS = [MAIN_LAUNCHER_PATH, "/cip/launch/888debug", "/cis/launch/888debug"];

export function isLauncherPath(path: string): boolean {

    if(!path) {
        return false;
    }

    path = path.toLowerCase();
    for(let i = 0; i < LAUNCHER_PATHS.length; i++) {
        if(path.startsWith(LAUNCHER_PATHS[i])) {
            return true;
        }
    }

    return false;
}